import { EPropellerDirectionWithRespectToTheQuay, EPropellerEquippedWithNozzles, ETypeOfPropeller, ETypeOfQuay, EUnitOfMeasure } from '../shared/enum';

export const getMinimumWaterDepth = (designWaterLevel: number, designDredgingLevel: number) => designWaterLevel - designDredgingLevel;

export const getEffectivePowerUsedByThePropeller = (maximumPowerOfThePropeller: number, percentageOfUseInPortManeuvers: number) =>
    Math.trunc((maximumPowerOfThePropeller * percentageOfUseInPortManeuvers) / 100);

export const getCoefficentC3 = (propellerEquippedWithNozzles: EPropellerEquippedWithNozzles) => (propellerEquippedWithNozzles == EPropellerEquippedWithNozzles.Yes ? 1.17 : 1.48);

export const getVerticalDistanceBetweenTheAxisOfThePropellerAndTheKell = (propellerDiameter: number, typeOfPropeller: ETypeOfPropeller, unitOfMeasure: EUnitOfMeasure) => {
    let offset = unitOfMeasure == EUnitOfMeasure.Metric ? 3 : 9.8;
    switch (typeOfPropeller) {
        case ETypeOfPropeller.MainPropeller:
            return propellerDiameter / 2;
        case ETypeOfPropeller.BowThruster:
            return propellerDiameter / 2 + offset;
        default:
            break;
    }
};

export const getSlopeParameter = (quaySlope: number) => {
    if (quaySlope == 90) quaySlope = 0; //Comment in Excel: Attivo solo se "type of quay" = "sloped" o "sloped with piles". Altrimenti sempre = 0
    let radiansB12 = quaySlope * (Math.PI / 180);
    let radians40 = 40 * (Math.PI / 180);
    let result = Math.round(Math.sqrt(1 - Math.pow(Math.sin(radiansB12) / Math.cos(radians40), 2)) * 100) / 100;
    return result;
};

export const getPropellerDistanceFromQuayL = (propellerDirectionWithRespectToTheQuay: number, typeOfQuay: number, typeOfPropeller: number, vesselBeamBs: number, unitOfMeasure: EUnitOfMeasure) => {
    const value = typeOfPropeller === ETypeOfPropeller.MainPropeller ? (unitOfMeasure == EUnitOfMeasure.Metric ? 20 : 65) : unitOfMeasure == EUnitOfMeasure.Metric ? 15 : 49;
    if (propellerDirectionWithRespectToTheQuay === EPropellerDirectionWithRespectToTheQuay.Parallel) {
        return null;
    } else if (typeOfQuay === ETypeOfQuay.Vertical) {
        if (typeOfPropeller === ETypeOfPropeller.MainPropeller) {
            return vesselBeamBs / 2 > value ? Math.round((vesselBeamBs / 2) * 100) / 100 : value;
        } else {
            return vesselBeamBs / 3 > value ? Math.round((vesselBeamBs / 3) * 100) / 100 : value;
        }
    } else {
        return null;
    }
};

export const getHorizontalDistanceBetweenPropellerAxisAndTheSlopeToe = (
    propellerDirectionWithRespectToTheQuay: number,
    typeOfQuay: number,
    typeOfPropeller: number,
    vesselBeamBs: number,
    unitOfMeasure: EUnitOfMeasure,
) => {
    const value = typeOfPropeller === ETypeOfPropeller.MainPropeller ? (unitOfMeasure == EUnitOfMeasure.Metric ? 20 : 65) : unitOfMeasure == EUnitOfMeasure.Metric ? 15 : 49;

    if (propellerDirectionWithRespectToTheQuay === EPropellerDirectionWithRespectToTheQuay.Parallel) {
        return null;
    } else if (typeOfQuay === ETypeOfQuay.Sloped || typeOfQuay === ETypeOfQuay.SlopedWithPiles) {
        if (typeOfPropeller === ETypeOfPropeller.MainPropeller) {
            return vesselBeamBs / 2 > value ? Math.round((vesselBeamBs / 2) * 100) / 100 : value;
        } else {
            return Math.round((vesselBeamBs / 3) * 100) / 100;
        }
    } else {
        return null;
    }
};
